<template>
<router-link to='product_detail'>
    <div @click="choiceProduct(ProductObj)" >
        
    
        <div href="#" class="card card-sm card-product-grid" >
            <a href="#" class="img-wrap"> <img :src="ProductImg"> </a>
            <figcaption class="info-wrap">
                <a href="#" class="descricao">{{ProductDescricao }}</a>
                <div class="fabricante">{{ProductFabricante}}</div> <!-- price-wrap.// -->
                <div class="preco">R$ {{ProductPreco}}</div> <!-- price-wrap.// -->

            </figcaption>
 
            <div class="d-grid p-1 ">
                <ButtonAddProduct
                :ProductId='ProductId'
                :PrecoVenda='ProductPreco'
                :User='UserId'
                />
            </div>
        </div>

    </div>
</router-link>
</template>

<script>
import ButtonAddProduct from '../Form/ButtonAdd1Product'
import {mapActions} from 'vuex'

    export default {
        components: {
            ButtonAddProduct,
        },
        props: {
            ProductImg: {
                type: String,
            },
            ProductDescricao: {
                type: String,
            },
            ProductFabricante: {
                type: String,
            },
            ProductPreco: {
                type: String,
            },
            ProductId: {
                type: Number,
            },
            ProductObj: {
                type: Object,
            },
            UserId:{
                type:String
            }
        },
        methods: {
        ...mapActions('product_car_list',['ActionSetChoicedProduct']),
         choiceProduct(product) {
            
            this.ActionSetChoicedProduct(product)
        }
        
        },

    }
</script>

<style lang="css" scoped>

button[data-v-b3d0df04] {

    background-color: var(--main-red-black);
    border-radius: 0.375rem;
    color: var(--main-white);
    font-size: 1.1857rem;
    font-weight: bold;
    padding: .2rem .5rem;
    width: 100%;
}


.card {
    position: relative;
    display: flex;
    flex-direction: column;
    max-width: 20rem;
    max-height: 17rem;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 0.1rem solid var(--main-red-white);
    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.25);
    border-radius: .1rem ;
    
    
}


.descricao{
font-family: Roboto;
font-style:normal;
font-weight:500;
font-size: 1rem;
line-height: 1rem;

/* identical to box height */
display: flex;
align-items: left;
text-align: left;
text-transform: uppercase;
color: var(--main-black);
}
.fabricante{
font-family: Roboto;
font-style:normal;
font-weight:normal;
font-size: 0.8rem;
line-height: 1.9rem;

text-transform: uppercase;
color: var(--main-black);
}
.preco{
font-family: Roboto;
font-style: normal;
font-weight: 900;
font-size: 1.3rem;
line-height: 1.2rem;
text-transform: uppercase;
margin-bottom:1rem;
color: #000000;
}


[class*='card-product'] .img-wrap img {
    height: 100%;
    max-width: 100%;
    width: 100%;
    display: inline-block;
    -o-object-fit: contain;
    object-fit: contain;
}

</style>